import { assortmentRoutes } from "@appretio/assortment";
import { operationsRoute, settingsRoute } from "@appretio/backstage";
import { designRoutes } from "@appretio/design";
import { inSeasonRoutes } from "@appretio/in-season";
import { lifecycleRoutes } from "@appretio/lifecycle-management";
import { marketingRoutes } from "@appretio/marketing";
import { preSeasonRoutes } from "@appretio/pre-season";
import { semanticThemeTokens } from "@appretio/ui-kit";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { APP_REDIRECTS } from "./appRedirects";
import { AppLayout } from "./components/appLayout/AppLayout";
import { AuthGuard } from "./components/authGuard/AuthGuard";
import { LegacyRedirect } from "./components/legacyRedirect/LegacyRedirect";
import { ProductionRedirect } from "./components/productionRedirect/ProductionRedirect";
import { ForbiddenPage } from "./pages/forbidden/ForbiddenPage";
import { NotFoundPage } from "./pages/not-found/NotFoundPage";
import { RestoreFeedbackPage } from "./pages/restore-feedback/RestoreFeedbackPage";

/** Modules not yet released: registered, and in the nav, outside production only. */
export function unreleasedRoutes(environment: string | undefined) {
  return environment === "production" ? [] : [designRoutes];
}

const unreleased = unreleasedRoutes(import.meta.env.VITE_ENVIRONMENT);

export const routes = [
  {
    element: <ProductionRedirect />,
    children: [
      {
        element: <AuthGuard />,
        children: [
          {
            element: (
              <AppLayout
                navRoutes={[
                  preSeasonRoutes,
                  assortmentRoutes,
                  inSeasonRoutes,
                  marketingRoutes,
                  lifecycleRoutes,
                  ...unreleased
                ]}
              />
            ),
            children: [
              {
                path: "/",
                index: true,
                element: <Navigate to={APP_REDIRECTS["/"]} replace />,
                handle: {
                  background: semanticThemeTokens.backgroundGradient[1]
                }
              },
              {
                ...preSeasonRoutes
              },
              // Outside `navRoutes`: `buildNavItems` lists every non-index
              // child, label or not.
              ...Object.entries(APP_REDIRECTS)
                .filter(([from]) => from !== "/")
                .map(([from, to]) => ({
                  path: from.slice(1),
                  element: <LegacyRedirect to={to} />
                })),
              {
                ...assortmentRoutes
              },
              {
                ...inSeasonRoutes
              },
              {
                ...marketingRoutes
              },
              {
                ...lifecycleRoutes
              },
              ...unreleased,
              // Feedback restore links (feedback table / Teams card): fetch
              // the report, then forward into the reported page with the
              // restore payload in router state. Inside the AuthGuard, so the
              // ?org= hint and path+search survive the Auth0 round trip.
              {
                path: "restore-feedback/:feedbackId",
                element: <RestoreFeedbackPage />,
                handle: {
                  background: semanticThemeTokens.backgroundGradient[1]
                }
              },
              settingsRoute,
              operationsRoute,
              {
                path: "forbidden",
                element: <ForbiddenPage />,
                handle: {
                  background: semanticThemeTokens.backgroundGradient[1]
                }
              },
              {
                path: "*",
                element: <NotFoundPage />,
                handle: {
                  background: semanticThemeTokens.backgroundGradient[1]
                }
              }
            ]
          }
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes);
